const doc = [({"zh_cn":({"adminConstantHotelPushMessageGroupStatus":({"created":"已创建", "pushed":"发送", "pushing":"发送"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;